import React from 'react';
import { Show, SimpleShowLayout, TextField, EditButton } from 'react-admin';
import { makeStyles } from '@material-ui/core';
import { ViewTitle } from '../ui';
import { UserContextTitle } from './UserContextTitle';
import { UserContextSubtitle } from './UserContextSubtitle';
export const UserContextShow = props => {
    const classes = useStyles(props);
    return (React.createElement(React.Fragment, null,
        React.createElement(ViewTitle, null),
        React.createElement(Show, Object.assign({}, props, { title: React.createElement(UserContextTitle, Object.assign({ actions: React.createElement(EditButton, null) }, props)), actions: null }),
            React.createElement(SimpleShowLayout, { className: classes.root },
                React.createElement(TextField, { className: classes.field, source: "userDetails.username" }),
                React.createElement(TextField, { className: classes.field, source: "userDetails.lastName" }),
                React.createElement(TextField, { className: classes.field, source: "userDetails.firstName" }),
                React.createElement(TextField, { className: classes.field, source: "userDetails.email" }),
                React.createElement(UserContextSubtitle, null),
                React.createElement(TextField, { className: classes.field, source: "userDetails.password", type: "password" })))));
};
const useStyles = makeStyles(theme => ({
    root: {
        padding: `${theme.spacing(4)}px !important`,
    },
    field: {
        width: 456,
    },
}), {
    name: 'Layer7UserContextShow',
});
//# sourceMappingURL=UserContextShow.js.map